/**
 * Orders module — route definitions.
 *
 * Imported and registered by App.tsx. One module owns the Order entity (list /
 * detail / new / edit) AND its OC commercial register (variation editor,
 * approval surface, OC + Final Invoice documents) — all under the /staff/orders
 * namespace (plus the public token-auth approval surface).
 */

import { lazy } from 'react';

// Order entity pages (formerly the projects module).
export const OrdersList = lazy(() => import('./pages/OrdersList'));
export const OrderNew = lazy(() => import('./pages/OrderNew'));
export const OrderDetail = lazy(() => import('./pages/OrderDetail'));
export const OrderEdit = lazy(() => import('./pages/OrderEdit'));

// OC register surfaces.
export const RaiseVariation = lazy(() => import('./pages/RaiseVariation'));
/** Public, token-auth customer surface — outside AppLayout (see App.tsx). */
export const ApproveVariation = lazy(() => import('./pages/ApproveVariation'));
/** Staff-facing printable OC document — standalone (no AppLayout chrome) so the
 *  A4 print stays clean, same convention as ClientQuoteView. */
export const OrderConfirmationDocument = lazy(() => import('./pages/OrderConfirmationDocument'));
/** Staff-facing printable Final Invoice — standalone, same A4 convention. */
export const FinalInvoiceDocument = lazy(() => import('./pages/FinalInvoiceDocument'));

export const ORDER_ROUTES = {
  list: '/staff/orders',
  new: '/staff/orders/new',
  detail: '/staff/orders/:id',
  edit: '/staff/orders/:id/edit',
  raiseVariation: '/staff/orders/:id/variation',
  approveVariation: '/approve-variation/:token',
  document: '/staff/orders/:id/order-confirmation',
  finalInvoice: '/staff/orders/:id/final-invoice',
} as const;
